export class DataCatalogDatasetHealthIssue {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "kind",
            "baseName": "kind",
            "type": "DataCatalogDatasetHealthIssueKind",
            "format": ""
        },
        {
            "name": "since",
            "baseName": "since",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "detail",
            "baseName": "detail",
            "type": "string",
            "format": ""
        },
        {
            "name": "severity",
            "baseName": "severity",
            "type": "DataCatalogDatasetHealthIssueSeverity",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DataCatalogDatasetHealthIssue.attributeTypeMap;
    }
    constructor() {
    }
}
